import { Component, OnInit } from '@angular/core';
import {Constants} from '../../../../../shared/Constants';

@Component({
  selector: 'app-landing-page-footer',
  templateUrl: './landing-page-footer.component.html',
  styleUrls: ['./landing-page-footer.component.scss']
})
export class LandingPageFooterComponent implements OnInit {

   vendor: string;
   year: number;

  constructor() { }

  ngOnInit() {
    this.vendor = Constants.VENDOR;
    this.year = new Date().getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/pages/landing-page/common/landing-page-footer/landing-page-footer.component.ts